import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "row p-0 m-0" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "col-3 d-xl-none" }, null, -1);
const _hoisted_3 = { class: "col-9 col-xl-2 mt-1 mb-1" };
const _hoisted_4 = ["src"];
const _hoisted_5 = { class: "col-3 d-xl-none text-muted mt-1 mb-1" };
const _hoisted_6 = { class: "col-9 col-xl-6 mt-1 mb-1" };
const _hoisted_7 = { class: "mt-1" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_9 = { class: "col-3 d-xl-none text-muted mt-1 mb-1 pt-1" };
const _hoisted_10 = {
    key: 0,
    class: "col-9 col-xl-2 mt-1 mb-1 text-lg-center"
};
const _hoisted_11 = {
    key: 1,
    class: "col-9 col-xl-2 d-flex mt-1 mb-1"
};
const _hoisted_12 = { class: "col-3 d-xl-none text-muted mt-1 mb-1" };
const _hoisted_13 = { class: "col-9 col-xl-2 text-xl-end mt-1 mb-1" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_15 = { class: "small" };
const _hoisted_16 = { class: "col-3 col-xl-2 mt-0 mb-1 text-muted text-truncate" };
const _hoisted_17 = {
    class: "col-9 col-xl-10 mt-0 mb-1 fw-bolder",
    style: { "white-space": "pre" }
};
const _hoisted_18 = { class: "row p-0 m-0" };
const _hoisted_19 = { class: "col-3 col-xl-2 mt-1 mb-1 text-muted text-truncate" };
const _hoisted_20 = { class: "col-6 col-xl-8 mt-1 mb-1 text-truncate" };
const _hoisted_21 = { class: "col-3 col-xl-2 mt-1 mb-1 fw-bolder text-end" };
const _hoisted_22 = {
    key: 2,
    class: "row p-0 m-0"
};
const _hoisted_23 = { class: "col-3 col-xl-2 mt-1 mb-1 text-muted text-truncate" };
const _hoisted_24 = {
    class: "col-9 col-xl-10 mt-1 mb-1",
    style: { "white-space": "pre" }
};
const _hoisted_25 = { class: "row p-0 m-0" };
const _hoisted_26 = { class: "col-3 col-xl-2 mt-1 mb-1 text-muted" };
const _hoisted_27 = { class: "col-9 col-xl-10 mt-1 mb-1" };
const _hoisted_28 = ["href"];
const _hoisted_29 = {
    key: 4,
    class: "row p-0 m-0 border-top bg-light",
    style: { "border-top-style": "dotted !important" }
};
const _hoisted_30 = { class: "col-12 p-2 m-0 d-flex justify-content-end" };
const _hoisted_31 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_link = _resolveComponent("g-link");
    const _component_g_product_delivery_time = _resolveComponent("g-product-delivery-time");
    const _component_g_quantity_field = _resolveComponent("g-quantity-field");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass([_ctx.isReadOnly ? 'border-bottom pt-1 pb-1' : 'pt-3 pb-3'])
    }, [
        _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
                (_ctx.item.image?.url)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.$utils.mediaUrlWithSize(_ctx.item.image?.url, 80),
                        class: "d-block ui-w-60 ui-bordered",
                        alt: ""
                    }, null, 8, _hoisted_4))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Item')), 1),
            _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_g_link, {
                    src: 'to://c/' + _ctx.item.catalogID + '/p/' + _ctx.item.productNumber,
                    tabindex: "-1",
                    class: "d-block text-dark fw-bold"
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.item.itemNumber), 1)
                    ]),
                    _: 1
                }, 8, ["src"]),
                _createElementVNode("div", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.item.caption1) + " ", 1),
                    _hoisted_8,
                    _createTextVNode(_toDisplayString(_ctx.item.caption2), 1)
                ]),
                _createVNode(_component_g_product_delivery_time, {
                    options: _ctx.item.deliveryTime,
                    class: "fw-bold mt-1"
                }, null, 8, ["options"])
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Quantity')), 1),
            (_ctx.isReadOnly || _ctx.item.itemType === 'COF')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$utils.formatNumberWithDcp(_ctx.item.quantity, _ctx.item.quantityData?.unitDcp)) + " " + _toDisplayString(_ctx.item.quantityData?.unit), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_g_quantity_field, {
                        "input-attr": { class: 'text-center' },
                        quantity: _ctx.item.quantityData,
                        "data-object": _ctx.item,
                        onValueChanged: _cache[0] || (_cache[0] = ($event) => (_ctx.updateLine($event, _ctx.item))),
                        "data-member": "quantity",
                        "data-mode": "model"
                    }, null, 8, ["quantity", "data-object"])
                ])),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$tc('client.Commerce.Carts.TotalAmount')), 1),
            _createElementVNode("div", _hoisted_13, [
                _createElementVNode("b", null, _toDisplayString(_ctx.item.totalNetAmountText), 1),
                (_ctx.item.singlePriceText && _ctx.item.singlePriceText !== 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_14,
                        _createElementVNode("span", _hoisted_15, [
                            _createElementVNode("i", null, "(" + _toDisplayString(_ctx.item.singlePriceText) + ")", 1)
                        ])
                    ], 64))
                    : _createCommentVNode("", true)
            ])
        ]),
        (_ctx.item.properties && _ctx.item.properties.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.item.properties, (record, index) => {
                return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(['row p-0 m-0', (index === (_ctx.item.properties.length - 1) && ((_ctx.item.options && _ctx.item.options.length > 0) || _ctx.item.comment || (_ctx.item.files && _ctx.item.files.length > 0))) ? 'border-bottom-dashed' : ''])
                }, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(record.caption), 1),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(record.valueCaption), 1)
                ], 2));
            }), 256))
            : _createCommentVNode("", true),
        (_ctx.item.options && _ctx.item.options.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.item.options, (option, index) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                        (index === 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.$tc('client.Commerce.Carts.Options')), 1)
                            ], 64))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_20, _toDisplayString(option.caption), 1),
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$utils.formatNumberWithDcp(option.price, 2)) + " " + _toDisplayString(_ctx.cart.currency), 1)
                ]));
            }), 256))
            : _createCommentVNode("", true),
        (_ctx.item.comment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Commen')), 1),
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.item.comment), 1)
            ]))
            : _createCommentVNode("", true),
        (_ctx.item.files && _ctx.item.files.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.item.files, (file, index) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                        (index === 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.$tc('client.Commerce.Carts.Documents')), 1)
                            ], 64))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("a", {
                            href: '/frontend/v1/system/storage/files/' + file.fileID,
                            target: "_blank"
                        }, _toDisplayString(file.fileName), 9, _hoisted_28)
                    ])
                ]));
            }), 256))
            : _createCommentVNode("", true),
        (!_ctx.isReadOnly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                    (_ctx.item.commands)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.item.commands, (cmd) => {
                            return (_openBlock(), _createElementBlock("button", {
                                class: _normalizeClass(['btn btn-sm me-2', cmd.styleClass]),
                                onClick: ($event) => (_ctx.cmdRunLineCommand(cmd.name, _ctx.item))
                            }, _toDisplayString(cmd.caption), 11, _hoisted_31));
                        }), 256))
                        : _createCommentVNode("", true),
                    _createElementVNode("button", {
                        class: "btn btn-outline-secondary btn-sm me-2",
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('command', { name: 'load' })))
                    }, _toDisplayString(_ctx.$tc('client.Common.Refresh')), 1),
                    _createElementVNode("button", {
                        class: "btn btn-outline-danger btn-sm",
                        onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.deleteLine($event, _ctx.item)))
                    }, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Command.Delete')), 1)
                ])
            ]))
            : _createCommentVNode("", true)
    ], 2));
}
